export const EDIT_PROFILE_STATE_KEY = 'editProfile'
export const FORM_EDIT_PROFILE_NAME = 'formEditProfile'
export const INFORMATIONS_PATH_STATE_KEY = 'informationsPath'

export const CONTENT_LOAD = 'Casino/EditProfile/LOAD'
export const CONTENT_LOAD_SUCCESS = 'Casino/EditProfile/LOAD_SUCCESS'
export const CONTENT_LOAD_ERROR = 'Casino/EditProfile/LOAD_ERROR'
